import { makeStyles } from '@material-ui/styles';
import fonts from 'styles/fonts';
import { colors } from 'styles/colors';
import styled from 'styled-components';
import theme from 'styles/theme';

const useStyles = makeStyles({
  presentation: {
    diaplay: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginTop: '64px',
  },
  modalPresentation: {
    outline: 'none',
  },
  modalCard: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '4px',
    background: colors.white,
    boxShadow:
      '0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2)',
    width: '100vw',
    height: 'calc(100vh - 64px)', // 64px == toolbar height
  },

  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px 24px 0 24px',
    alignItems: 'center',
    height: '67px',
    width: '100%',
  },
  modalHeaderItem: {
    display: 'flex',
    flexDirection: 'row',
  },
  headerTitle: {
    fontSize: fonts.sizes.xxlarge,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.18px',
    lineHeight: '24px',
    color: colors.gray,
    marginLeft: '20px',
  },
  headerIcon: {
    color: colors.gray,
    cursor: 'pointer',
  },
  modalBody: {
    padding: '32px 24px',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  container: {
    display: 'flex',
    position: 'relative',
    width: '100%',
    height: '100%',
    background: colors.white,
    wordBreak: 'break-all',
    overflowX: 'auto',

    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: '0px',
    },
  },
  boletim: {
    borderRight: '1px solid #a1a1a1',
    width: '350px',
  },
  formControl: {
    margin: theme.spacing(0),
    width: 170,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  bodyContent: {
    flexGrow: 1,

    '& > div:first-child': {
      paddingBottom: '34px',
    },
    '& > div': {
      paddingBottom: '24px',
    },
    '& > div:last-child': {
      paddingBottom: '0',
    },
  },
  gridContent: {
    '& > *': {
      marginTop: '24px',
      display: 'flex',
      alignItems: 'baseline',
    },
    '& > *:first-child': {
      marginTop: 0,
    },
  },
  inputList: {
    '& .MuiInputBase-root': {
      height: 'auto',
    },
    '& .MuiIconButton-root': {
      color: colors.black,
    },
  },
  formLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minWidth: '380px',
  },
  formInput: {
    color: colors.black,
  },
  formBaseInput: {
    '& .MuiFormHelperText-root': {
      color: colors.gray,
    },
  },
  w115: {
    width: '220px',
    borderRadius: '5px 0 0 5px !important',
    marginTop: '2px',
    height: '38px !important',
  },
  wArea: {
    width: '250px',
    borderRadius: '5px',
    marginTop: '2px',
    height: '38px !important',
  },
  btnAdd: {
    padding: '10px 7px 8px 9px',
    radius: '0 5px 5px 0 !important',
  },
  button: {
    width: '20px',
    padding: '6px 3px',
  },
  leftButton: {
    margin: '2px 0 0 -1px',
    padding: '0',
    minWidth: '30px !important',
    height: '38px !important',
    borderRadius: '0 5px 5px 0 !important',
    borderColor: 'darkgrey !important',
    color: '#757575',
  },
  labelFlutuante: {
    position: 'absolute',
    margin: '20px 0 0 0 ',
    backgroundColor: 'white !important',
    color: '#387ef9 !important',
    zIndex: 33,
    padding: '0 10px !important',
    fontSize: '14px !important',
  },
  divTextField: {
    width: '250px !important',
    minWidth: '30px !important',
    minHeight: '39px !important',
    borderRadius: '5px !important',
    borderColor: 'darkgrey !important',
    border: '1px solid darkgray',
    fontSize: '16px',
    backgroundColor: '#d3d3d34d',
    padding: '8px 12px',
    color: '#397ffe',
    fontWeight: 'bold',
  },
  MuiFormLabelRoot: {
    fontWeight: 'bold',
    position: 'absolute',
  },
});

export const Blocktabs = styled.div`
  display: flex;
  padding: 12px;
  justify-content: space-around;
  align-items: center;
  border-bottom: 1px solid #a1a1a1;
  box-shadow: #201f24;
  /* width: 533px; */

  .MuiButton-root {
    text-transform: capitalize !important;
  }

  .MuiButton-root {
    text-transform: capitalize !important;
  }
  .tabs {
    padding: 9px;
    text-align: center;
    /* width: 50%; */
    background: #fff;
    cursor: pointer;
    box-sizing: content-box;
    position: relative;
    outline: none;
  }

  .tabs:not(:last-child) {
    border: none;
  }

  .active-tabs {
    background: white;
    color: rgb(88, 147, 241);
    font-size: 1.125rem;
  }

  .active-tabs::before {
    content: '';
    display: block;
    position: absolute;
    top: 61px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% + 1px);
    height: 2px;
    background: rgb(88, 147, 241);
  }
`;

export const Title = styled.h2`
  font-size: 0.92rem;
  color: rgb(88, 147, 241);
`;

export const TitleType = styled.h2`
  font-size: 0.92rem;
  color: rgb(88, 147, 241);
  margin-right: 42px;
  margin-top: 23px;
`;

export const ContentTable = styled.div`
  flex-grow: 1;
  .content {
    background: white;
    padding: 40px 12px 0px 0px;
    height: 100%;
    display: none;

    hr {
      display: none;
    }
  }

  .content p {
    width: 68%;
    height: 100%;
  }
  .active-content {
    display: block;
    /* width: 512px; */

    margin-left: 20px;
  }
  .clusterFilter {
    display: flex;
    flex-direction: column;

    /* justify-content: space-between; */
    align-items: initial;
    /* width: 500px; */

    h3 {
      display: flex;
      align-items: center;
      color: rgb(88, 147, 241);
      font-size: 1rem;
      margin-bottom: 20px;
    }
  }
  .clusterFilterBop {
    display: flex;
    flex-direction: column;
    align-items: baseline;

    h3 {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      color: rgb(88, 147, 241);
      font-size: 1rem;
    }

    .MuiSelect-outlined.MuiSelect-outlined {
      padding: 10px;
    }
  }
  .dividerBopFilter {
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    align-items: center;
    margin-top: 34px;
  }
  .clusterFilterFornec {
    display: flex;
  }
  .options {
    display: flex;
    /* justify-content: center; */
    align-items: baseline;
    gap: 5px;

    #demo-simple-select-outlined {
      padding: 8px;
    }
  }
  .optionsArea {
    display: flex;
    justify-content: center;
    align-items: baseline;
    gap: 5px;

    #demo-simple-select-outlined {
      padding: 8px;
    }
  }
  .boxGrid {
    padding-top: 10px;
    height: 500px;
  }
`;
export const ListMachine = styled.div`
  padding-top: 20px;
  display: flex;
  justify-content: center;
  /* align-items: center; */
  flex-direction: column;

  h2 {
    width: 180px;
    font-size: 0.92rem;
  }
`;

export default useStyles;
